import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material"
import { createContext, useState } from "react"

type ConfirmationCallback = () => void /* | (() => Promise<void>) */

export type ConfirmActionOptionsType = {
    askConfirmation: (onConfirm: ConfirmationCallback, message?: string) => void
}

const defaultProvider: ConfirmActionOptionsType = {
    askConfirmation: () => null
}

const ConfirmActionContext = createContext(defaultProvider)

const ConfirmActionProvider = ({ children }: { children: React.ReactNode }) => {

    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const [dialogMessage, setDialogMessage] = useState<string>();
    const [onConfirmCallback, setOnConfirmCallback] = useState<() => void>(() => { console.log('callback') });

    const askConfirmation = (onConfirm: ConfirmationCallback, message?: string) => {
        setOnConfirmCallback(() => onConfirm);
        message && setDialogMessage(message);
        setOpenDialog(true);
    }

    const handleConfirm = () => {
        onConfirmCallback();
        setOpenDialog(false);
        setDialogMessage(undefined);
    }

    const handleCancel = () => {
        setOpenDialog(false);
        setDialogMessage(undefined);
    }

    return (
        <ConfirmActionContext.Provider value={{ askConfirmation }}>
            {
                openDialog &&
                <Dialog open={openDialog} fullWidth maxWidth='xs'>
                    <DialogContent>
                        <DialogContentText>
                            {
                                dialogMessage || "¿Está seguro que desea realizar esta acción?"
                            }
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='text'
                            color='primary'
                            onClick={handleCancel}
                        >
                            Cancelar
                        </Button>
                        <Button
                            variant='contained'
                            color='primary'
                            onClick={handleConfirm}
                        >
                            Confirmar
                        </Button>
                    </DialogActions>
                </Dialog>
            }
            {children}
        </ConfirmActionContext.Provider>
    )
}

export { ConfirmActionContext, ConfirmActionProvider }
